import { useEffect } from 'react';

const useClickOutsideGrouping = (elementRefs = [], callback) => {
  useEffect(() => {
    const handleMouseDown = ({ target }) => {
      let isContain = false;
      elementRefs.forEach(elementRef => {
        if (!isContain) {
          isContain = elementRef.current && elementRef.current?.contains(target);
        }
      });
      if (!isContain) {
        callback();
      }
    };
    const handleWindowBlur = () => {
      // handle click inside iframe
      if (document.activeElement.tagName === 'IFRAME' || document.activeElement === document.body) {
        callback();
      }
    };
    window.addEventListener('blur', handleWindowBlur);
    document.addEventListener('mousedown', handleMouseDown, { capture: true });
    return () => {
      window.removeEventListener('blur', handleWindowBlur);
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, [elementRefs, callback]);
};

export default useClickOutsideGrouping;
